import { ButtonGradientPrimary, ButtonOutlinedPrimary, ButtonSecondary } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

type ProfileSelectorFooterProps = {
    isEditing: boolean;
    isSubmitting: boolean;
    hasSelectedProfile: boolean;
    onCancel: () => void;
    /** Absent, no competency can be added on top of the profile. */
    onAddCompetencies?: () => void;
    onConfirm: () => void;
};

export const ProfileSelectorFooter = ({
    isEditing,
    isSubmitting,
    hasSelectedProfile,
    onCancel,
    onAddCompetencies,
    onConfirm,
}: ProfileSelectorFooterProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'mt-10 flex flex-col items-center justify-between gap-3 sm:flex-row'}>
            {hasSelectedProfile && onAddCompetencies && (
                <ButtonOutlinedPrimary
                    size={'md'}
                    onClick={onAddCompetencies}
                    dataTestId={'roster-selector-add'}
                    className={'border-teal border text-sm text-teal-400'}
                    fitContent={true}
                >
                    {t('competencies.competencyProfilesAdmin.selector.addCompetencies')}
                </ButtonOutlinedPrimary>
            )}

            <div className={'flex flex-col items-center gap-4 sm:ml-auto sm:flex-row'}>
                <ButtonSecondary
                    size={'md'}
                    onClick={onCancel}
                    disabled={isSubmitting}
                    dataTestId={'roster-selector-cancel-footer'}
                    className={'gap-2 border border-gray-300 text-sm'}
                    fitContent={true}
                >
                    {t('competencies.competencyProfilesAdmin.selector.cancel')}
                </ButtonSecondary>

                <ButtonGradientPrimary
                    size={'md'}
                    loading={isSubmitting}
                    disabled={!hasSelectedProfile || isSubmitting}
                    onClick={onConfirm}
                    dataTestId={'roster-selector-confirm'}
                    fitContent={true}
                    className={'text-sm'}
                >
                    {isEditing
                        ? t('competencies.competencyProfilesAdmin.selector.save')
                        : t('competencies.competencyProfilesAdmin.selector.confirm')}
                </ButtonGradientPrimary>
            </div>
        </div>
    );
};
